import React, { useContext, useEffect, useReducer } from 'react';
import { watchFullInfoReducer } from './watchFullInfoReducer';
import { AppContext, IAppContext } from 'appState/appContext';
import { IWatchContext, WatchContext } from '../../Watches/watchState/watchContext';
import {
	WatchFullInfoContext,
	watchFullInfoInitialState,
	IDataForPushArgs,
	TTypeOfModalWindow,
} from './watchFullInfoContext';
import { WatchFullInfoActionTypes } from './watchFullInfoActions';
import { IGetWatchInfo } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { getWatchInfo } from 'backend/watches';

export const WatchFullInfoState = ({ children }: JSX.ElementChildrenAttribute) => {
	const [state, dispatch] = useReducer(watchFullInfoReducer, watchFullInfoInitialState);
	const { showLoader, hideLoader } = useContext<IAppContext>(AppContext);
	const { IDForFullInfo } = useContext<IWatchContext>(WatchContext);
	const { refetch, response, loading } = useFetchData<IGetWatchInfo, string>(
		IDForFullInfo ? getWatchInfo : null,
		IDForFullInfo,
	);

	useEffect(() => {
		loading ? showLoader() : hideLoader();
	}, [loading]);

	useEffect(() => {
		response &&
			dispatch({
				type: WatchFullInfoActionTypes.SET_WATCH_FULL_INFO,
				payload: {
					watchFullInfo: response.data,
				},
			});
	}, [response]);

	useEffect(() => {
		refetch();

		return () => {
			dispatch({
				type: WatchFullInfoActionTypes.SET_WATCH_FULL_INFO,
				payload: {
					watchFullInfo: null,
				},
			});
		};
	}, [IDForFullInfo]);

	const setDataForPush = (dataForPush: Nullable<IDataForPushArgs>) => {
		dispatch({
			type: WatchFullInfoActionTypes.SET_DATA_FOR_PUSH,
			payload: {
				dataForPush,
			},
		});
	};

	const changeTypeOfModalWindow = (value: TTypeOfModalWindow) => {
		dispatch({
			type: WatchFullInfoActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW,
			payload: {
				typeOfModalWindow: value,
			},
		});
	};

	return (
		<WatchFullInfoContext.Provider
			value={{
				setDataForPush,
				changeTypeOfModalWindow,
				watchFullInfo: state.watchFullInfo,
				dataForPush: state.dataForPush,
				typeOfModalWindow: state.typeOfModalWindow,
			}}>
			{children}
		</WatchFullInfoContext.Provider>
	);
};
